import 'url-search-params-polyfill';

const parseQueryParams = (urlsearch) => {
  const search = new URLSearchParams(urlsearch);
  const params = {};
  for (const key of search.keys()) {
    params[key] = search.get(key);
  }

  return params;
};

export default parseQueryParams;
